export const SOFTLINE_API_TEMPLATE = 'softline/api/template';
export const SOFTLINE_API_QUERY_TEMPLATE = 'softline/api/quer-template';
export const SOFTLINE_API_QUERY_HISTORY = 'softline/api/query-history';

export const SOFTLINE_API_BOOKMARK =
  'portal-service/bookmark/{{category}}/{{subCategory}}';

export const SOFTLINE_API_BOOKMARK_DELETE = 'portal-service/bookmark/{{key}}';
